export default __webpack_public_path__ + "static/media/i_wdt_c_5.27cc8d1f.mp3";